import { motion } from 'framer-motion'
import { Code, Globe, Smartphone, ArrowRight } from 'react-feather'
import { Link } from 'react-router-dom'

import './Hero.css'

export default function Hero() {
  return (
    <div className="hero-section">
      {/* Content */}
      <div className="content-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="hero-content"
        >
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span className="company-name">EVOAXY</span>
            <br />
            Transforming Ideas into
            <span className="gradient-text"> Digital Reality</span>
          </motion.h1>
          
          <motion.p 
            className="hero-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Evoaxy Solutions - Your partner in software development, web & mobile solutions, 
            and digital transformation. We build the future of technology.
          </motion.p>
          
          <div className="button-group">
            <button className="button primary">
              Get Started
              <ArrowRight className="button-icon" />
            </button>
            <Link to="/services" className="button secondary" style={{ textDecoration: 'none' }}>
              Our Services
            </Link>
          </div>

          <div className="services-grid">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 }}
              className="service-card"
            >
              <Code className="service-icon" />
              <h3>Software Development</h3>
              <p>Custom solutions tailored to your business needs</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.0 }}
              className="service-card"
            >
              <Globe className="service-icon" />
              <h3>Web Development</h3>
              <p>Modern and responsive web applications</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.2 }}
              className="service-card"
            >
              <Smartphone className="service-icon" />
              <h3>Mobile Solutions</h3>
              <p>Native and cross-platform mobile apps</p>
            </motion.div>
          </div>
        </motion.div>
      </div>

      {/* Gradient Orbs */}
      <div className="gradient-orb orb-1" />
      <div className="gradient-orb orb-2" />
    </div>
  )
}